export const PAYMENT_ACTION = {
  LIST: 'CARD_LIST',
  CREATE: 'CARD_CREATE',
  POST_SECURE: 'POST_SECURE',
  CREATE_WITH_REDIRECT: 'CREATE_WITH_REDIRECT',
  DELETE: 'CARD_DELETE',
  SET_MAIN: 'SET_MAIN'
};